/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VcdsPersonaEnum = 'VLCR_CLOUD' | 'VLCR_ONPREM' | 'VMCFS' | 'VLSR' | 'VLSR_MTDR';

export const VcdsPersonaEnum = {

    VLCR_CLOUD: 'VLCR_CLOUD' as VcdsPersonaEnum,

    VLCR_ONPREM: 'VLCR_ONPREM' as VcdsPersonaEnum,

    VMCFS: 'VMCFS' as VcdsPersonaEnum,

    VLSR: 'VLSR' as VcdsPersonaEnum,

    VLSR_MTDR: 'VLSR_MTDR' as VcdsPersonaEnum
};

